module.exports = __webpack_public_path__ + "static/media/UWrittenwords.f0fb42cb.png";